// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swatches":"_4CqCt","active":"NR3RY","additional-swatches":"Ijcmy"};